import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../css/modules/Footer.module.css';
import { LICENCJA_PAGES, CONTACT_EMAIL } from '../seo/siteMeta';
import { przedmiotyLicencji, LICENCJA_PO_SLUGU } from '../data/licencje';

function Footer() {
  const year = new Date().getFullYear();
  const ppl = LICENCJA_PO_SLUGU['ppl-a'];
  const przedmioty = przedmiotyLicencji(ppl);

  return (
    <footer className={styles.footer}>
      <nav className={styles.footerGrid} aria-label="Stopka">
        <div className={styles.footerCol}>
          <h2 className={styles.footerHeading}>Uprawnienia</h2>
          {LICENCJA_PAGES.map(p => (
            <Link key={p.path} to={p.path}>
              {p.rodzina === 'bsp' ? `Egzamin na drona ${p.krotko}` : `Testy na ${p.nazwa}`}
            </Link>
          ))}
          <Link to="/cennik">Cennik dostępu</Link>
        </div>

        <div className={styles.footerCol}>
          <h2 className={styles.footerHeading}>Test i egzamin</h2>
          <Link to="/intro">Darmowy test bez rejestracji</Link>
          <Link to="/egzamin-teoretyczny-ulc">Egzamin teoretyczny w ULC</Link>
          <Link to="/ranking">Ranking graczy</Link>
        </div>

        <div className={styles.footerCol}>
          <h2 className={styles.footerHeading}>Nauka według przedmiotów</h2>
          {przedmioty.slice(0, 5).map(g => (
            <Link key={g.slug} to={`/nauka/${ppl.slug}/${g.slug}`}>{g.nazwa}</Link>
          ))}
          <Link to={`/nauka/${ppl.slug}`}>Wszystkie przedmioty</Link>
        </div>

        <div className={styles.footerCol}>
          <h2 className={styles.footerHeading}>Serwis</h2>
          <a href="/poradnik">Poradnik dla pilotów</a>
          <Link to="/o-nas">O nas</Link>
          <Link to="/kontakt">Kontakt</Link>
          <Link to="/regulamin">Regulamin</Link>
          <Link to="/polityka-prywatnosci">Polityka prywatności</Link>
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
        </div>
      </nav>

      <p className={styles.footerNote}>
        © {year} Pilotuje.pl - testy online przygotowujące do egzaminów teoretycznych dla
        pilotów samolotowych i operatorów bezzałogowców. Serwis ma charakter edukacyjny, nie jest
        oficjalną stroną Urzędu Lotnictwa Cywilnego, a pytania są autorskie i nie pochodzą
        z Krajowego Banku Pytań.
      </p>
    </footer>
  );
}

export default Footer;
